import { breadcrumbAnatomy } from '@chakra-ui/anatomy';

export const BREADCRUMB_PARTS = [...breadcrumbAnatomy.keys, 'list'] as const;
